import { LDContext, LDClient, initialize } from 'launchdarkly-react-client-sdk';

let globalClient: Promise<LDClient>;

async function getClient(context: LDContext): Promise<LDClient> {
  if (!globalClient) {
    globalClient = (async () => {
      const newClient = initialize(process.env.NEXT_PUBLIC_LAUNCHDARKLY_ID!, context, {});
      await newClient.waitUntilReady();

      return newClient;
    })();
  }
  return globalClient;
}

export async function executeClientVariation(key: string, context: LDContext) {
  const client = await getClient(context);
  client.variation(key);
}
